// Generated from src/img/svg/zob.svg

export const Zob = (props) => {
  return (
    <svg viewBox="0 0 77 24.189" {...props}>
      <g data-name="Ebene 2">
        <g data-name="Ebene 1">
          <g data-name="Ebene 2">
            <g data-name="Ebene 1-2">
              <path
                d="M12 24.19H0v-24h11.5a7 7 0 0 0-2 .3 11.984 11.984 0 0 0 2.5 23.7"
                style={{ fill: "none" }}
              />
              <path
                d="M16.1 14.989v2H8.3v-2l5-5.9H8.5v-2H16v2l-5 5.9zM36.5.19h-.2a12.05 12.05 0 0 0-9.6 9.6 1.32 1.32 0 0 1-1.4 1.1h-.1a1.41 1.41 0 0 1-1.4-1.1v-.3A11.69 11.69 0 0 0 12.9.19ZM38.4 24.19H12a12.07 12.07 0 0 0 11.7-9.5l.1-.3a1.38 1.38 0 0 1 1.3-1 1.42 1.42 0 0 1 1.5 1.2 12.084 12.084 0 0 0 11.8 9.6M65 .19a11.71 11.71 0 0 0-11.7 9.3l-.1.4a1.5 1.5 0 0 1-1.5 1.1 1.41 1.41 0 0 1-1.4-1.1.9.9 0 0 1-.1-.5 11.37 11.37 0 0 0-9.4-9.2ZM77 .19v24H38.5a11.7 11.7 0 0 0 11.6-9.3l.1-.4a1.41 1.41 0 0 1 1.4-1.1 1.625 1.625 0 0 1 1.5 1.1l.1.4a12.39 12.39 0 0 0 11.8 9.3c6.2 0 12-5 12-11.3 0-7.5-5.4-12.7-12-12.7Z"
                style={{ fill: "none" }}
              />
              <path
                d="M36.5.19h4.3a12.4 12.4 0 0 0-4.3 0"
                style={{ fill: "#353535" }}
              />
              <path
                d="M65 .19a11.71 11.71 0 0 0-11.7 9.3l-.1.4a1.5 1.5 0 0 1-1.5 1.1 1.41 1.41 0 0 1-1.4-1.1.9.9 0 0 1-.1-.5 11.37 11.37 0 0 0-9.4-9.2h-4.5a12.05 12.05 0 0 0-9.6 9.6 1.32 1.32 0 0 1-1.4 1.1h-.1a1.41 1.41 0 0 1-1.4-1.1v-.3A11.69 11.69 0 0 0 12.9.19h-1.3a7 7 0 0 0-2 .3 11.973 11.973 0 0 0 2.4 23.7 12.07 12.07 0 0 0 11.7-9.5l.1-.3a1.38 1.38 0 0 1 1.3-1 1.42 1.42 0 0 1 1.5 1.2 12.084 12.084 0 0 0 11.8 9.6h.1a11.7 11.7 0 0 0 11.6-9.3l.1-.4a1.41 1.41 0 0 1 1.4-1.1 1.625 1.625 0 0 1 1.5 1.1l.1.4a12.39 12.39 0 0 0 11.8 9.3c6.2 0 12-5 12-11.3 0-7.5-5.4-12.7-12-12.7m-48.9 16.8H8.3v-2l5-5.9H8.5v-2H16v2l-5 5.9h5.1Zm22.4.4a5.3 5.3 0 1 1 5.4-5.3 5.357 5.357 0 0 1-5.4 5.3m30.3-2.3a2.2 2.2 0 0 1-.7.9 2.3 2.3 0 0 1-1.2.6 4.1 4.1 0 0 1-1.6.2h-3.9v-9.7H65a8 8 0 0 1 1.7.2 3.3 3.3 0 0 1 1.2.5 2.7 2.7 0 0 1 .7.8 3.6 3.6 0 0 1 .2 1.1 1.3 1.3 0 0 1-.1.6l-.3.6c-.1.2-.3.3-.5.5a2 2 0 0 1-.8.4 2.73 2.73 0 0 1 1.4.8 1.9 1.9 0 0 1 .5 1.3 1.64 1.64 0 0 1-.2 1.2m-3.4-2.4h-1.6v2.5h1.6s1.5.1 1.5-1.3c-.1-1.2-1.5-1.2-1.5-1.2m1.2-2.7c0-1.3-1.5-1.2-1.5-1.2h-1.3v2.4H65c.4 0 1.6.1 1.6-1.2"
                style={{ fill: "#353535" }}
              />
            </g>
          </g>
          <ellipse
            cx="38.5"
            cy="12.089"
            rx="3.1"
            ry="3.2"
            style={{ fill: "#353535" }}
          />
        </g>
      </g>
    </svg>
  );
};
